/* ============================================================
   MY TELLURIDE CHRISTMAS — cart behaviour
   Progressive enhancement only. Every form here still works with
   JavaScript disabled: it posts to /cart/add and lands on /cart.

   2026-10-20: install dates are now required. The product page
   carries the booking fields (snippets/mtc-booking-inline.liquid);
   Add to cart is blocked until arrival + departure are filled, and
   the values are mirrored into cart attributes (what the install bot
   and the order-confirmation email read). The cart page's Check out
   button is gated the same way as a safety net for items added from
   the home page or collection cards.
   ============================================================ */
(function () {
  'use strict';

  var ADD_SELECTOR = 'form[action*="/cart/add"]';
  var ATTR_KEYS = ['Property location', 'Arrival date', 'Departure date', 'Property access', 'Access notes'];

  function routePrefix() {
    // Preserve locale/market path prefixes like /en-ca
    var m = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i);
    return m ? m[0] : '';
  }

  function flash(btn) {
    if (!btn) return;
    var original = btn.innerHTML;
    btn.classList.add('is-added');
    btn.innerHTML = 'Added ✓';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.innerHTML = original;
    }, 1200);
  }

  function saveAttributes(attributes) {
    return fetch(routePrefix() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  /* ---------- refresh whatever cart UI the theme provides ---------- */
  function refreshThemeCart() {
    // Dawn / Refresh / Sense / Craft / Studio / Taste and most OS 2.0 themes
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');

    if (drawer && typeof drawer.renderContents === 'function') {
      return fetchCartSections().then(function (sections) {
        drawer.renderContents({ sections: sections });
      });
    }
    if (notification && typeof notification.renderContents === 'function') {
      return fetchCartSections().then(function (sections) {
        notification.renderContents({ sections: sections });
      });
    }

    // No known drawer — bump the bubble count and let the user carry on.
    return updateCartCount();
  }

  function fetchCartSections() {
    var ids = ['cart-drawer', 'cart-icon-bubble', 'cart-notification', 'cart-live-region-text']
      .filter(function (id) { return document.getElementById('shopify-section-' + id) || document.querySelector(id); });

    return fetch(routePrefix() + '/?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; });
  }

  function updateCartCount() {
    return fetch(routePrefix() + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* non-fatal */ });
  }

  /* ---------- intercept add-to-cart submits on MTC cards ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(ADD_SELECTOR)) return;
    if (!form.querySelector('[data-mtc-add]')) return; // only our cards

    e.preventDefault();

    var btn = form.querySelector('[data-mtc-add]');
    if (btn) btn.disabled = true;

    var body = new FormData(form);

    fetch(routePrefix() + '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Sold out, quantity limit, etc. Surface the real reason.
          window.alert(res.data.description || res.data.message || 'Sorry, that item could not be added.');
          return;
        }
        flash(btn);
        return refreshThemeCart();
      })
      .catch(function () {
        // Network trouble — fall back to the plain form post.
        form.submit();
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  });

  /* ---------- product page: booking fields gate Add to cart ---------- */
  function initInlineBooking() {
    var box = document.getElementById('mtc-booking-inline');
    if (!box) return;

    var productForm = document.getElementById(box.getAttribute('data-form-id') || '')
      || document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[data-type="add-to-cart-form"]');
    if (!productForm) return;
    // getAttribute, not .id: the form contains <input name="id">, which
    // shadows the element's id property with the input itself.
    var formId = productForm.getAttribute('id');
    if (!formId) {
      formId = 'mtc-product-form';
      productForm.setAttribute('id', formId);
    }

    var fields = box.querySelectorAll('[data-mtc-attr]');
    fields.forEach(function (el) { el.setAttribute('form', formId); });

    var arrival = box.querySelector('[data-mtc-arrival]');
    var depart = box.querySelector('[data-mtc-depart]');
    var error = document.getElementById('mtc-booking-inline-error');

    function collect() {
      var attributes = {};
      fields.forEach(function (el) { attributes[el.getAttribute('data-mtc-attr')] = el.value; });
      return attributes;
    }

    function syncDates() {
      if (arrival.value) depart.min = arrival.value;
      if (arrival.value && depart.value && depart.value < arrival.value) depart.value = '';
    }

    function valid() {
      var ok = !!arrival.value && !!depart.value;
      box.classList.toggle('is-invalid', !ok);
      arrival.classList.toggle('is-missing', !arrival.value);
      depart.classList.toggle('is-missing', !depart.value);
      if (error) error.hidden = ok;
      return ok;
    }

    box.addEventListener('change', function () {
      syncDates();
      if (arrival.value && depart.value) valid();
      // Keep the cart page in sync even if they never add to cart.
      saveAttributes(collect()).catch(function () { /* non-fatal */ });
    });

    // Capture phase runs before the theme's own product-form handler.
    document.addEventListener('submit', function (e) {
      if (e.target !== productForm) return;
      if (!valid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        (arrival.value ? depart : arrival).focus();
        return;
      }
      saveAttributes(collect()).catch(function () { /* line-item properties still travel with the add */ });
    }, true);

    syncDates();
    if (error) error.hidden = true;
  }

  /* ---------- cart page: install details + Check out gate ---------- */
  function initBookingForm() {
    var form = document.getElementById('mtc-booking-form');
    if (!form) return;

    var saved = document.getElementById('mtc-booking-saved');
    var error = document.getElementById('mtc-booking-error');
    var arrival = document.getElementById('mtc-arrival');
    var depart = document.getElementById('mtc-depart');
    var timer;

    function showSaved() {
      if (!saved) return;
      saved.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(function () { saved.classList.remove('is-visible'); }, 2200);
    }

    function save() {
      var attributes = {};
      new FormData(form).forEach(function (value, key) {
        var m = key.match(/^attributes\[(.+)\]$/);
        if (m) attributes[m[1]] = value;
      });
      return saveAttributes(attributes)
        .then(showSaved)
        .catch(function () { /* the Save button still works */ });
    }

    // Departure can't precede arrival.
    function syncDates() {
      if (!arrival || !depart) return;
      if (arrival.value) depart.min = arrival.value;
      if (arrival.value && depart.value && depart.value < arrival.value) {
        depart.value = '';
      }
    }

    function valid() {
      var ok = !!(arrival && arrival.value) && !!(depart && depart.value);
      form.classList.toggle('is-invalid', !ok);
      if (arrival) arrival.classList.toggle('is-missing', !arrival.value);
      if (depart) depart.classList.toggle('is-missing', !depart.value);
      if (error) error.hidden = ok;
      return ok;
    }

    form.addEventListener('change', function () { syncDates(); if (arrival.value && depart.value) valid(); save(); });
    form.addEventListener('submit', function (e) {
      // Save via AJAX and stay put rather than round-tripping the page.
      e.preventDefault();
      if (valid()) save();
    });

    // Gate the theme's Check out button (form="cart", name="checkout").
    document.addEventListener('submit', function (e) {
      var cartForm = e.target;
      if (!cartForm || cartForm.id !== 'cart') return;
      var submitter = e.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'checkout') return;
      if (cartForm.getAttribute('data-mtc-ready') === '1') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (!valid()) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        (arrival.value ? depart : arrival).focus();
        return;
      }

      save().then(function () {
        cartForm.setAttribute('data-mtc-ready', '1');
        if (typeof cartForm.requestSubmit === 'function') {
          cartForm.requestSubmit(submitter);
        } else {
          cartForm.submit();
        }
      });
    }, true);

    syncDates();
    if (error) error.hidden = true;
  }

  function init() {
    initInlineBooking();
    initBookingForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
